
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
// Suppress performance violation warnings in development
import './utils/suppressViolations.ts';
import { initializeXssMonitor } from './utils/xssProtection';

// Register service worker for push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}

// Fix Safari back/forward cache issues that can break React hooks
// When the page is restored from the bfcache (e.g. user taps browser Back
// from an external site like Kashier), force a full reload so React
// re-initializes correctly instead of running with a null dispatcher.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

// Initialize XSS monitoring
initializeXssMonitor();

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
